import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = { class: "row align-items-center justify-content-between mt-3" }
const _hoisted_4 = { class: "form-group mb-0 col-12 col-lg-4 col-md-6 mt-3 mt-md-0" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "table-responsive overflow-auto" }
const _hoisted_7 = { class: "table table-striped" }
const _hoisted_8 = { class: "popover-custom" }
const _hoisted_9 = { class: "popover-content position-right" }
const _hoisted_10 = { class: "popover-custom" }
const _hoisted_11 = { class: "popover-content position-right" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = { class: "text-right" }

import overviewCoachingService from '@/api/CoachingOverview/PrivateCoaching';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
// @ts-ignore
import {getOfficeByUserRoleDropdown} from '@/shared/dropdowns';
// @ts-ignore
import debounce from 'lodash/debounce';
import {downloadFile, getSortIconClass} from '@/shared/functions';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import Menu from '@/views/App/CoachingOverview/PrivateCoaching/Menu.vue';
import Search from '@/views/App/CoachingOverview/PrivateCoaching/NewAndActive/Search.vue';
import {computed, onMounted, ref} from 'vue';
import {ICoachingOverviewList, IPagination} from "@/interfaces/CoachingOverview/PrivateCoaching/ICoachingOverview";
import {ICoachingOverviewFilters} from "@/interfaces/CoachingOverview/ICoachingOverviewFIlters";
import {piniaUserStore} from "@/store/piniaUserStore";
import ClientSpecialFeaturesPopover from "@/components/ClientSpecialFeaturesPopover.vue";
import BackButton from "@/components/button/BackButton.vue";
import ExcelExportButton from "@/components/ExcelExportButton.vue";
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import PortalButton from "@/views/App/CoachingOverview/PrivateCoaching/PortalButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value?.roles?.[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyKey = companySettings.value?.companyKey;

const TypedPopover = ClientSpecialFeaturesPopover as unknown as {
  new(): {
    $slots: {
      trigger: () => any
      content: () => any
    }
  }
}

const coachingList = ref<ICoachingOverviewList>({
  data: [],
  pagination: {
    current_page: 1,
    items_per_page: 10,
    total_pages: 0,
  } as IPagination,
});

const filters = ref<ICoachingOverviewFilters>({
  officeIds: [],
  operationType: '',
  page: 1,
  limit: 10,
  sortBy: 'firstName',
  searchTerm: '',
  orderBy: 'ASC',
});


// const filters = ref({
//   'officeIds[]': [],
//   operationType: '',
// });

const filterDebounce = ref({
  searchTerm: '',
});

const operationTypeDropdown = ref([]);
const officeDropdown = ref([]);
const isSearching = ref(false);
const isLoaded = ref(false);
const perPageValue = ref(25)
const isExcelLoaded = ref(false);

const debouncedSearch = debounce(async (query: string) => {
  const finalFilters: ICoachingOverviewFilters = {
    page: 1,
    limit: 10,
    sortBy: 'firstName',
    ...filterDebounce.value, // merge optional fields
  };
  await getCoachingList(1, undefined, finalFilters);
}, 600);

const handleDebounceSearch = (event: any) => {
  debouncedSearch(event.target.value);
};

async function getCoachingList(
    page: number | undefined = 1,
    perPage?: number,
    passedFilters?: ICoachingOverviewFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = coachingList.value?.pagination?.items_per_page;

  perPageValue.value = perPage ?? perPageRes;

  try {
    const {data} = await overviewCoachingService.getNewAndActiveList({
      ...(passedFilters ? passedFilters : filters.value),
      ...filterDebounce.value,
      page: page,
      limit: perPage ?? perPageRes,
    });

    coachingList.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

function getIconClass(key: string) {
  return getSortIconClass(filters.value, key);
}

async function sortBy(key: string) {
  filters.value = {
    ...filters.value,
    sortBy: key,
    orderBy: filters.value.orderBy === 'DESC' || filters.value.sortBy !== key ? 'ASC' : 'DESC',
  };
  await getCoachingList();
}

async function getOperationTypeDropdown() {
  operationTypeDropdown.value = getEnums?.value?.privateCoachingOperationTypes || [];
}

async function getExcelExport() {
  isExcelLoaded.value = true

  try {
    await downloadFile(
        '/private-coaching-overview/new-and-active-excel-export',
        undefined,
        {
          ...filters.value,
          'officeIds[]': filters.value.officeIds,
          searchTerm: filterDebounce.value.searchTerm
        },
        false,
        'GET'
    )
  } finally {
    isExcelLoaded.value = false
  }
}

onMounted(async () => {
  await Promise.all([
    getCoachingList(1, perPageValue.value),
    getOperationTypeDropdown(),
    getOfficeByUserRoleDropdown(officeDropdown),
  ]);

  isLoaded.value = true;
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(BackButton, {
              label: _ctx.$t('general.button.back'),
              to: { name: 'coachingOverview' },
              marginBottom: "5"
            }, null, 8, ["label"]),
            _cache[58] || (_cache[58] = _createElementVNode("h6", { class: "element-header" }, "Übersicht", -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[57] || (_cache[57] = _createElementVNode("h5", { class: "form-header mb-4" }, "Einzelcoaching", -1)),
              _createVNode(Menu),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                operationTypeDropdown: operationTypeDropdown.value,
                officeDropdown: officeDropdown.value,
                onSearch: getCoachingList
              }, null, 8, ["filters", "loading", "operationTypeDropdown", "officeDropdown"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createVNode(PerPage, {
                    values: [10, 25, 50, 100],
                    perPage: perPageValue.value,
                    "onUpdate:perPage": getCoachingList
                  }, null, 8, ["perPage"]),
                  _createVNode(ExcelExportButton, {
                    style: {"margin-right":"15px"},
                    label: _ctx.$t('general.excel_export'),
                    loading: isExcelLoaded.value,
                    onClick: getExcelExport
                  }, null, 8, ["label", "loading"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    name: "searchTerm",
                    class: "form-control",
                    onInput: handleDebounceSearch,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterDebounce.value.searchTerm) = $event)),
                    placeholder: _ctx.$t('general.button.search')
                  }, null, 40, _hoisted_5), [
                    [_vModelText, filterDebounce.value.searchTerm]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[47] || (_cache[47] = _createElementVNode("th", null, null, -1)),
                      _cache[48] || (_cache[48] = _createElementVNode("th", null, null, -1)),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (sortBy('status')), ["prevent"]))
                        }, [
                          _cache[24] || (_cache[24] = _createElementVNode("span", null, "status", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('status'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (sortBy('firstName')), ["prevent"]))
                        }, [
                          _cache[25] || (_cache[25] = _createElementVNode("span", null, "Vorname", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('firstName'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (sortBy('lastName')), ["prevent"]))
                        }, [
                          _cache[26] || (_cache[26] = _createElementVNode("span", null, "Nachname", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('lastName'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (sortBy('operationType')), ["prevent"]))
                        }, [
                          _cache[27] || (_cache[27] = _createElementVNode("span", null, "Maßnahmenart", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('operationType'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (sortBy('aaNumber')), ["prevent"]))
                        }, [
                          _cache[28] || (_cache[28] = _createElementVNode("span", null, "JC/AA Nr", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('aaNumber'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (sortBy('location')), ["prevent"]))
                        }, [
                          _cache[29] || (_cache[29] = _createElementVNode("span", null, "Standort", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('location'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (sortBy('clerk')), ["prevent"]))
                        }, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Sachbearbeiter", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('clerk'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (sortBy('startDate')), ["prevent"]))
                        }, [
                          _cache[31] || (_cache[31] = _createElementVNode("span", null, "Start", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('startDate'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (sortBy('endDate')), ["prevent"]))
                        }, [
                          _cache[32] || (_cache[32] = _createElementVNode("span", null, "Ende", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('endDate'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (sortBy('unitsDone')), ["prevent"]))
                        }, [
                          _cache[33] || (_cache[33] = _createElementVNode("span", null, "Stand", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('unitsDone'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (sortBy('unitsDone')), ["prevent"]))
                        }, [
                          _cache[34] || (_cache[34] = _createElementVNode("span", null, "Stand %", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('unitsDone'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (sortBy('coach1')), ["prevent"]))
                        }, [
                          _cache[35] || (_cache[35] = _createElementVNode("span", null, "Coach 1", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('coach1'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (sortBy('coach1UnitsDone')), ["prevent"]))
                        }, [
                          _cache[36] || (_cache[36] = _createElementVNode("span", null, "UE Coach 1", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('coach1UnitsDone'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (sortBy('coach2')), ["prevent"]))
                        }, [
                          _cache[37] || (_cache[37] = _createElementVNode("span", null, "Coach 2", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('coach2'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (sortBy('coach2UnitsDone')), ["prevent"]))
                        }, [
                          _cache[38] || (_cache[38] = _createElementVNode("span", null, "UE Coach 2", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('coach2UnitsDone'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (sortBy('coach3')), ["prevent"]))
                        }, [
                          _cache[39] || (_cache[39] = _createElementVNode("span", null, "Coach 3", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('coach3'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (sortBy('coach3UnitsDone')), ["prevent"]))
                        }, [
                          _cache[40] || (_cache[40] = _createElementVNode("span", null, "UE Coach 3", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('coach3UnitsDone'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (sortBy('coach4')), ["prevent"]))
                        }, [
                          _cache[41] || (_cache[41] = _createElementVNode("span", null, "Coach 4", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('coach4'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (sortBy('coach4UnitsDone')), ["prevent"]))
                        }, [
                          _cache[42] || (_cache[42] = _createElementVNode("span", null, "UE Coach 4", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('coach4UnitsDone'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "text-right",
                          onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (sortBy('notSignedUnits')), ["prevent"]))
                        }, [
                          _cache[43] || (_cache[43] = _createElementVNode("span", null, "UN fehlt", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('notSignedUnits'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (sortBy('gevaStatus')), ["prevent"]))
                        }, [
                          _cache[44] || (_cache[44] = _createElementVNode("span", null, "Geva Testung", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('gevaStatus'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("div", {
                          class: "btn-link",
                          onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (sortBy('documents')), ["prevent"]))
                        }, [
                          _cache[45] || (_cache[45] = _createElementVNode("span", null, "Einführungsunterlagen", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('documents'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (sortBy('lastUnit')), ["prevent"]))
                        }, [
                          _cache[46] || (_cache[46] = _createElementVNode("span", null, "Letzter Termin", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('lastUnit'))
                          }, null, 2)
                        ])
                      ]),
                      _cache[49] || (_cache[49] = _createElementVNode("th", null, "CV/GEVA", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coachingList.value.data, (coaching) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: coaching.id
                      }, [
                        _createElementVNode("td", null, [
                          _createVNode(PortalButton, {
                            "company-key": _unref(companyKey),
                            "operation-type": coaching.nameOfCoaching.operationType,
                            id: coaching.id
                          }, null, 8, ["company-key", "operation-type", "id"])
                        ]),
                        _createElementVNode("th", null, [
                          (coaching.client?.specialFeatures || coaching.client?.specialFeaturesForCoach)
                            ? (_openBlock(), _createBlock(_unref(TypedPopover), {
                                key: 0,
                                clientData: coaching.client,
                                userRole: _unref(currentUserRole),
                                maxWidth: "450px"
                              }, {
                                trigger: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                  _createElementVNode("span", { class: "exclamation-badge" }, "!", -1)
                                ]))]),
                                _: 1
                              }, 8, ["clientData", "userRole"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(coaching?.statusTranslated), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createTextVNode(_toDisplayString(coaching?.unemployed?.phone) + " ", 1),
                              _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(coaching?.unemployed?.address) + " ", 1),
                              _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(coaching?.unemployed?.zip) + " ", 1),
                              _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(coaching?.unemployed?.city) + " ", 1),
                              _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1))
                            ]),
                            _createTextVNode(" " + _toDisplayString(coaching?.unemployed?.firstName), 1)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.lastName), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.nameOfCoaching?.operationTypeTranslated), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.aaNumber), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployed?.location?.name), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.clerk), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.startDate), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.endDate), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unitsDone), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              (
                    coaching.unitsDoneByCoach !== null &&
                    coaching.unitsDoneByCoach.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(coaching.unitsDoneByCoach, (data, index) => {
                                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                                      _createTextVNode(_toDisplayString(data.firstName) + " " + _toDisplayString(data.lastName) + " " + _toDisplayString(data.units) + " ", 1),
                                      _cache[55] || (_cache[55] = _createElementVNode("br", null, null, -1))
                                    ]))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("span", _hoisted_12, "Keine Daten"))
                            ]),
                            _createTextVNode(" " + _toDisplayString(coaching?.unitsDonePercent) + " % ", 1)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(coaching?.coach1?.firstName) + " " + _toDisplayString(coaching?.coach1?.lastName), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(coaching?.unitsDoneCoach1), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.coach2?.firstName) + " " + _toDisplayString(coaching?.coach2?.lastName), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(coaching?.unitsDoneCoach2), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.coach3?.firstName) + " " + _toDisplayString(coaching?.coach3?.lastName), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(coaching?.unitsDoneCoach3), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.coach4?.firstName) + " " + _toDisplayString(coaching?.coach4?.lastName), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(coaching?.unitsDoneCoach4), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(coaching?.notSignedUnits), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.gevaStatusTranslated), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.introductoryDocumentsStatus), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.lastUnit), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'unemployedDocumentUpload', params: {
                      id: Number(coaching.unemployed.id),
                      routeForBack: 'privateCoachingNewAndActiveList'
                    } },
                            class: "btn btn-primary"
                          }, {
                            default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                              _createTextVNode(" CV/GEVA ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (coachingList.value?.pagination?.total_pages > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    totalPages: coachingList.value?.pagination?.total_pages,
                    currentPage: coachingList.value?.pagination?.current_page,
                    totalItems: coachingList.value?.pagination?.total_items,
                    perPage: coachingList.value?.pagination?.items_per_page,
                    onPagechanged: getCoachingList
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})